import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import ContactSection from '../components/ContactSection';

const ContactPage = () => {
  return (
    <div className="min-h-screen bg-white">
      <Navbar onContactClick={() => {}} alwaysSolid={true} />
      
      <main className="pt-24 lg:pt-32 pb-20">
        <ContactSection />
      </main>

      <Footer onContactClick={() => {}} />
    </div>
  );
};

export default ContactPage;
